import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { VerticalDivider } from '@hero/atoms';
import { DEVICE } from '@hero/constants';

const Header = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  ${Button.S.Button} {
    font-size: 14px;
  }

  ${DEVICE.mobile.max} {
    ${VerticalDivider} {
      display: none;
    }
  }
`;

const Recognition = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const RecognitionName = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

export { Header, Recognition, RecognitionName };
